import { IDataAccessor } from "@core/data-access";
import { AbstractAccessorService } from "@core/data-access/abstract-accessor.service";
import { IUniqueKeyRestService } from "./unique-key-rest";
import { IResponse } from "@core/data-access/model";
import { data, error } from "jquery";
import { TurnaroundTime } from "@modules/shipping/model/domain/turnaround-time";
import { isUndefined } from "angular";

export class UniqueKeyRestService extends AbstractAccessorService<number> implements IUniqueKeyRestService {

    public readonly $name: string = "uniqueKeyRestService";

    public static readonly $inject: string[] = ["$accessor", "$q","$timeout"];
    private _idCache: number[];
    private cacheSize: number = 20;

    constructor(public $accessor: IDataAccessor<number>, public $q: angular.IQService,public $timeout: angular.ITimeoutService) {
        super();
    }

    public getIds(size: number): angular.IPromise<IResponse<Array<number>>> {
        const defer = this.$q.defer<IResponse<Array<number>>>()
        if (!isUndefined(this._idCache) && (size < this._idCache.length)) {
            // 直接从缓存里获取
            this.$timeout(() => {
                const resIds = this._idCache.splice(0, size);
                this._idCache = this._idCache.splice(size - 1);
                const resObj: IResponse<Array<number>> = {
                    success: true,
                    data: resIds
                }
                defer.resolve(resObj);
            })

        } else {
            if (isUndefined(this._idCache)) {
                this._idCache = [];
            }
            // 需要获取的id数量：(需要的Id数量 - 本地id缓存数量)+本地默认需要缓存的Id数量
            let getQty = (size - this._idCache.length) + this.cacheSize;
            this.$accessor<Array<number>, number, { size: number }, string>(this.$name, "getIds", {
                parameter: { size: getQty }
            }).then(idsResp => {
                const newIds = idsResp.data;
                this._idCache.push(...newIds);
                const resIds = this._idCache.splice(0, size);
                this._idCache = this._idCache.splice(size - 1);
                const resObj: IResponse<Array<number>> = {
                    success: true,
                    data: resIds
                }
                defer.resolve(resObj);
            }, error => {
                defer.reject(error);
            })
        }

        // return this.$accessor<Array<number>, number, { size: number }, string>(this.$name, "getIds", {
        //     parameter: { size: size }
        // });

        return defer.promise
    }
}